import Api from "../../../../../Services/Api";
import { fetchDataAsync } from "../../../../../Services/Utils";
import { HttpStatus } from "../../../../common/Constants";

export const fetchAvailableSalesOrderUnits = async ({
  kodeCabang,
  kodeVariant,
  idWarna,
  nomorRangka = "",
  setError,
  ...additionalFilters
}) => {
  const result = await fetchDataAsync({
    asyncFn: Api.create("NAGAMAS_TRANSACTION").getListUnitForSalesOrder,
    setError,
    menuName: "Faktur Jual - Data Unit",
    args: {
      ...additionalFilters,
      kodeCabang,
      kodeVariant,
      idWarna,
      nomorRangka,
    },
  });

  if (
    !result.ok ||
    result.data.status !== HttpStatus.SUCCESS ||
    !Array.isArray(result.data.data)
  ) {
    return [];
  }

  return result.data.data;
};
